import React from "react";
import { SOCIALS } from "@/lib/socials";

/**
 * Inline social-icon row. Used in the footer, contact page, and order
 * confirmation panel. Variants control colouring and size — defaults are
 * tuned for use against a light background.
 */
export default function SocialIcons({ variant = "outline", size = "md", testidPrefix = "social" }) {
  const sizes = {
    sm: "w-8 h-8",
    md: "w-9 h-9",
    lg: "w-11 h-11",
  };
  const variants = {
    outline: "border border-black/15 hover:border-black hover:bg-black hover:text-white text-black",
    solid: "bg-white text-black hover:bg-black hover:text-white",
    ghost: "text-white/70 hover:text-white hover:bg-white/10 border border-white/15",
  };
  const sz = sizes[size] || sizes.md;
  const vr = variants[variant] || variants.outline;
  return (
    <div className="flex items-center gap-3" data-testid={`${testidPrefix}-row`}>
      {SOCIALS.map((s) => (
        <a
          key={s.key}
          href={s.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`MotoWear on ${s.label}`}
          className={`${sz} flex items-center justify-center transition-colors ${vr}`}
          data-testid={`${testidPrefix}-${s.key}`}
          title={`${s.label} — ${s.handle}`}
        >
          <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4" aria-hidden="true">
            <path d={s.icon} />
          </svg>
        </a>
      ))}
    </div>
  );
}
